import React, { useState, useEffect, useRef } from "react";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardBody.jsx";
import store from "store";
import EditIcon from "@material-ui/icons/Edit";

import config from "config.js";
import { Link } from "react-router-dom";
import Button from "common/components/CustomButtons/Button.jsx";
import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import loadContent from "core-module/hoc/loadContent";
import Contract from "./Contract.jsx";
import SignaturePad from "./SignaturePad.jsx";
import ReviewContract from "./ReviewContract.jsx";
import DownloadContract from "./DownloadContract.jsx";

import Agreement from "./Agreement.jsx";
import ReviewAgreement from "./ReviewAgreement.jsx";
import DownloadAgreement from "./DownloadAgreement.jsx";

import withStyles from "@material-ui/core/styles/withStyles";

const importedStyle = dashboardStyle;
const styles = {
  cardCategory: importedStyle.cardCategory,
  cardTitle: { ...importedStyle.cardTitle, margin: "30px", padding: "20px" },
  cardIconTitle: importedStyle.cardIconTitle,
  stats: importedStyle.stats,
  fileInput: {
    display: "none",
  },
  buttonStyle: {
    margin: "30px",
  },
};

function inArray(needle, haystack) {
  var length = haystack.length;
  for (var i = 0; i < length; i++) {
    if (haystack[i] == needle) return true;
  }
  return false;
}

function dataURItoBlob(dataURI) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  var byteString = atob(dataURI.split(",")[1]);

  // separate out the mime component
  var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

  // write the bytes of the string to an ArrayBuffer
  var ab = new ArrayBuffer(byteString.length);
  var ia = new Uint8Array(ab);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  //Old Code
  //write the ArrayBuffer to a blob, and you're done
  //var bb = new BlobBuilder();
  //bb.append(ab);
  //return bb.getBlob(mimeString);

  //New Code
  return new Blob([ab], { type: mimeString });
}

const subscriberContractFlags = [
  "NEEDDOC_CONTRACTASSUME",
  "NEEDDOC_CONTRACTNEW",
  "NEEDDOC_CONTRACTVER",
];

const agreementFlags = ["NEEDDOC_60GHZTRIALAGREEMENT"];

function Signature(props) {
  const [mode, setMode] = useState("contract");
  const [page, setPage] = useState("");
  const [name, setName] = useState("");
  const [name2, setName2] = useState("");
  const [type, setType] = useState("");
  const [ip, setIp] = useState("");
  const [term, setTerm] = useState(0);
  const [contractTemplateId, setContractTemplateId] = useState("");
  const [contractTemplateOptions, setContractTemplateOptions] = useState([]);
  const [selectionLocked, setSelectionLocked] = useState(false);
  const [packageSelectionRequired, setPackageSelectionRequired] = useState(
    false
  );
  const [tempContractId, setTempContractId] = useState(null);
  const [contractStatus, setContractStatus] = useState(null);
  const [contractResign, setContractResign] = useState(false);
  const [contractResignType, setContractResignType] = useState(null);
  const [agreementDescription, setAgreementDescription] = useState("");
  const [agreementCount, setAgreementCount] = useState(0);
  const [contractCount, setContractCount] = useState(0);
  const [signature, setSignature] = useState(null);
  const { classes } = props;
  const getList = props.getList;
  const activeUserId = props.ids?.user;
  const initializedUserIdRef = useRef(null);
  useEffect(() => {
    getList((oGet, id) => {
      const isPreinstall = oGet("ispreinstall", "value");
      const loadedContractStatus = oGet("contractstatus");
      const loadedContractResign = oGet("contractResign", "value");
      const loadedContractResignType = oGet("contractResignType");
      const loadedTempContractId = oGet("tempcontractid");

      setName(oGet("name"));
      setName2(oGet("name2"));
      setType(oGet("type"));
      setIp(oGet("ip"));
      setContractStatus(loadedContractStatus);
      const loadedContractTemplateOptions =
        oGet("contracttemplateoptions", "value") || [];
      const normalizedContractTemplateOptions = Array.isArray(
        loadedContractTemplateOptions
      )
        ? loadedContractTemplateOptions
        : [];
      setContractTemplateOptions(normalizedContractTemplateOptions);
      setSelectionLocked(Boolean(oGet("selectionlocked", "value")));
      setPackageSelectionRequired(
        Boolean(oGet("packageselectionrequired", "value"))
      );
      const loadedContractTemplateId = oGet("contracttemplateid", "value");
      if (loadedContractTemplateId) {
        setContractTemplateId(loadedContractTemplateId);
        const selectedContractTemplateOption = normalizedContractTemplateOptions.find(
          (option) => String(option.id) === String(loadedContractTemplateId)
        );
        if (selectedContractTemplateOption?.term) {
          setTerm(Number(selectedContractTemplateOption.term));
        }
      }
      setContractResign(!isPreinstall && loadedContractResign);
      setContractResignType(loadedContractResignType);
      setAgreementDescription(oGet("agreementdescription"));
      setAgreementCount(oGet("agreementcount"));
      setContractCount(oGet("contractcount"));

      if (loadedTempContractId > 0) {
        setTempContractId(loadedTempContractId);
      }

      if (initializedUserIdRef.current === activeUserId) {
        return;
      }

      initializedUserIdRef.current = activeUserId;

      if (loadedTempContractId > 0) {
        if (
          loadedContractResign &&
          inArray(loadedContractResignType, agreementFlags)
        ) {
          setMode("agreement");
          setPage("reviewagreement");
        } else {
          setMode("contract");
          setPage("reviewcontract");
        }
        return;
      }

      if (
        (isPreinstall && loadedContractStatus === "I") ||
        (loadedContractResign &&
          inArray(loadedContractResignType, subscriberContractFlags))
      ) {
        setMode("contract");
        setPage("contract");
      } else if (
        loadedContractResign &&
        inArray(loadedContractResignType, agreementFlags)
      ) {
        setPage("agreement");
        setMode("agreement");
      }
    });
  }, [activeUserId, getList]);

  function getNameParameters() {
    if (type == "m" || type == "p") {
      return `&name=${encodeURIComponent(name)}`;
    } else {
      return `&name=${encodeURIComponent(
        name2
      )}&companyname=${encodeURIComponent(name)}`;
    }
  }

  function buildUrlParameters() {
    var parameters = "&docpost=t";
    const contractTemplateParameters = contractTemplateId
      ? `&contracttemplateid=${encodeURIComponent(contractTemplateId)}`
      : "";

    if (contractResign) {
      if (contractResignType == "NEEDDOC_CONTRACTNEW") {
        parameters +=
          `&term=${term}` + contractTemplateParameters + getNameParameters();
      }
      if (contractResignType == "NEEDDOC_CONTRACTASSUME") {
        parameters += getNameParameters();
      }
    } else {
      parameters += `&term=${term}` + contractTemplateParameters;
    }
    return parameters;
  }

  async function submitContract() {
    //console.log(canvasRef.current.getSaveData());
    if (showContractTermAgreements() && term === 0) {
      alert("Please choose between the two term options to proceed.");
      return;
    }

    if (showContractTermAgreements() && contractTemplateOptions.length > 0) {
      const selectedContractTemplateOption = contractTemplateOptions.find(
        (option) => String(option.id) === String(contractTemplateId)
      );
      if (
        !selectedContractTemplateOption ||
        Number(selectedContractTemplateOption.term) !== Number(term)
      ) {
        alert("Please choose a valid contract option to proceed.");
        return;
      }
    }

    const storeState = store.getState();
    const endPoint = `user.${storeState.services.ids.user}/contract`;

    //URL built from config file and specified end point (target)
    let url = `${config.API.ADDRESS}?target=${endPoint}` + buildUrlParameters();
    const formData = new FormData();
    formData.append("file", dataURItoBlob(signature));

    //myInit is the second fetch() argument used to specify methods, headers, body...
    let myInit: init = {
      method: "post",
      headers: {
        "x-omicron": storeState.services.api.JRR,
      },
      body: formData,
    };
    try {
      var res = await fetch(url, myInit);
    } catch (e) {
      alert(e.message);

      throw e;
    }
    var resjson = await res.json();

    if (resjson.error === 0) {
      const tempcontractid = resjson.list[0].tempcontractid;
      setTempContractId(tempcontractid);

      goToDownload();
    } else {
      alert("Error: " + resjson.message);
    }
  }

  async function submitAgreement() {
    //console.log(canvasRef.current.getSaveData());

    const storeState = store.getState();
    const endPoint = `user.${storeState.services.ids.user}/agreement`;

    //URL built from config file and specified end point (target)
    let url = `${config.API.ADDRESS}?target=${endPoint}&agreement=${contractResignType}&docpost=t`;
    const formData = new FormData();
    formData.append("file", dataURItoBlob(signature));

    //myInit is the second fetch() argument used to specify methods, headers, body...
    let myInit: init = {
      method: "post",
      headers: {
        "x-omicron": storeState.services.api.JRR,
      },
      body: formData,
    };
    try {
      var res = await fetch(url, myInit);
    } catch (e) {
      alert(e.message);

      throw e;
    }
    var resjson = await res.json();

    if (resjson.error === 0) {
      const tempcontractid = resjson.list[0].tempcontractid;
      setTempContractId(tempcontractid);
      goToDownloadAgreement();
    } else {
      alert("Error: " + resjson.message);
    }
  }

  function goToSignaturePad() {
    setPage("signaturepad");
  }
  function goToContract() {
    setPage("contract");
  }

  function goToReview() {
    if (mode === "contract") {
      setPage("reviewcontract");
    } else {
      setPage("reviewagreement");
    }
  }
  function goToDownload() {
    setPage("downloadcontract");
  }
  function goToDownloadAgreement() {
    setPage("downloadagreement");
  }

  function showContractTermAgreements() {
    if (contractResign && contractResignType) {
      if (contractResignType == "NEEDDOC_CONTRACTNEW") {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  function isNameChange() {
    if (
      contractResign &&
      contractResignType &&
      contractResignType == "NEEDDOC_CONTRACTASSUME"
    ) {
      return true;
    } else {
      return false;
    }
  }

  if (packageSelectionRequired) {
    return (
      <GridContainer justify="center">
        <GridItem xs={12} md={10}>
          <Card>
            <CardBody>
              <h2>Choose your internet plan first</h2>
              <p>
                Review your package, extras and prices before completing your
                subscriber agreement. The agreement will use your saved plan.
              </p>
              <Button
                color="primary"
                component={Link}
                to={config.MYACCOUNT.APP_PATH + "/user/preinstallpackage"}
              >
                Choose your plan
              </Button>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }

  if (mode === "contract") {
    if (contractStatus === "C" && !contractResign) {
      return (
        <GridContainer justify="center">
          <GridItem xs={12} md={10}>
            <Card>
              <CardHeader color="primary" icon>
                <CardIcon color="primary">
                  <EditIcon />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Contract</h4>
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}>
                  Your contract has been approved. Our staff will contact you
                  soon.
                  <br />
                </h4>

                <GridContainer align="center" justify="center">
                  <GridItem xs={12}>
                    <Link to={config.MYACCOUNT.APP_PATH}>
                      <Button
                        className={classes.buttonStyle}
                        color="primary"
                        disabled={false}
                      >
                        Go to Main Screen
                      </Button>
                    </Link>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      );
    }

    if (
      (contractStatus === "P" && !contractResign) ||
      (contractResign && contractCount > 0)
    ) {
      return (
        <GridContainer justify="center">
          <GridItem xs={12} md={10}>
            <Card>
              <CardHeader color="primary" icon>
                <CardIcon color="primary">
                  <EditIcon />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Contract</h4>
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}>
                  The contract you submited is waiting for approval. Please
                  check again later.
                  <br />
                </h4>

                <GridContainer align="center" justify="center">
                  <GridItem xs={12}>
                    <Link to={config.MYACCOUNT.APP_PATH}>
                      <Button
                        className={classes.buttonStyle}
                        color="primary"
                        disabled={false}
                      >
                        Go to Main Screen
                      </Button>
                    </Link>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      );
    }

    if (page === "contract") {
      return (
        <Contract
          term={term}
          isNameChange={isNameChange}
          showContractTermAgreements={showContractTermAgreements}
          contractResignType={contractResignType}
          contractResign={contractResign}
          setTerm={setTerm}
          contractTemplateId={contractTemplateId}
          contractTemplateOptions={contractTemplateOptions}
          selectionLocked={selectionLocked}
          setContractTemplateId={setContractTemplateId}
          name={name}
          setName={setName}
          name2={name2}
          setName2={setName2}
          type={type}
          ip={ip}
          goToSignaturePad={goToSignaturePad}
          mainPanelRef={props.mainPanelRef}
        />
      );
    }
    if (page === "signaturepad") {
      return (
        <SignaturePad
          setSignature={setSignature}
          goToContract={goToContract}
          term={term}
          setTempContractId={setTempContractId}
          goToReview={goToReview}
          mainPanelRef={props.mainPanelRef}
        />
      );
    }
    if (page === "reviewcontract") {
      return (
        <ReviewContract
          contractResignType={contractResignType}
          showContractTermAgreements={showContractTermAgreements}
          isNameChange={isNameChange}
          signature={signature}
          term={term}
          setTerm={setTerm}
          contractTemplateId={contractTemplateId}
          contractTemplateOptions={contractTemplateOptions}
          selectionLocked={selectionLocked}
          setContractTemplateId={setContractTemplateId}
          name={name}
          name2={name2}
          type={type}
          ip={ip}
          submitContract={submitContract}
          goToSignaturePad={goToSignaturePad}
          tempContractId={tempContractId}
          mainPanelRef={props.mainPanelRef}
        />
      );
    }
    if (page === "downloadcontract") {
      return (
        <DownloadContract
          goToSignaturePad={goToSignaturePad}
          tempContractId={tempContractId}
          mainPanelRef={props.mainPanelRef}
        />
      );
    }
  } else if (mode === "agreement") {
    if (agreementCount > 0) {
      return (
        <GridContainer justify="center">
          <GridItem xs={12} md={10}>
            <Card>
              <CardHeader color="primary" icon>
                <CardIcon color="primary">
                  <EditIcon />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Agreement</h4>
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}>
                  The agreement you submited is waiting for approval. Please
                  check again later.
                  <br />
                </h4>

                <GridContainer align="center" justify="center">
                  <GridItem xs={12}>
                    <Link to={config.MYACCOUNT.APP_PATH}>
                      <Button
                        className={classes.buttonStyle}
                        color="primary"
                        disabled={false}
                      >
                        Go to Main Screen
                      </Button>
                    </Link>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      );
    }

    if (page === "agreement") {
      return (
        <Agreement
          agreementDescription={agreementDescription}
          agreementType={contractResignType}
          term={term}
          contractResignType={contractResignType}
          contractResign={contractResign}
          name={name}
          setName={setName}
          name2={name2}
          setName2={setName2}
          type={type}
          ip={ip}
          goToSignaturePad={goToSignaturePad}
          mainPanelRef={props.mainPanelRef}
        />
      );
    }
    if (page === "signaturepad") {
      return (
        <SignaturePad
          setSignature={setSignature}
          goToContract={goToContract}
          term={term}
          setTempContractId={setTempContractId}
          goToReview={goToReview}
          mainPanelRef={props.mainPanelRef}
        />
      );
    }

    if (page === "reviewagreement") {
      return (
        <ReviewAgreement
          agreementDescription={agreementDescription}
          contractResignType={contractResignType}
          showContractTermAgreements={showContractTermAgreements}
          isNameChange={isNameChange}
          signature={signature}
          term={term}
          setTerm={setTerm}
          name={name}
          name2={name2}
          type={type}
          ip={ip}
          submitContract={submitAgreement}
          goToSignaturePad={goToSignaturePad}
          tempContractId={tempContractId}
          mainPanelRef={props.mainPanelRef}
        />
      );
    }
    if (page === "downloadagreement") {
      return (
        <DownloadAgreement
          goToSignaturePad={goToSignaturePad}
          tempContractId={tempContractId}
          mainPanelRef={props.mainPanelRef}
        />
      );
    }
  }

  return null;
}

export default loadContent(
  "user.session/contract",
  withStyles(styles)(Signature)
);
